import(/* webpackMode: "eager" */ "/vercel/path1/app/auth/page.tsx");
